import React, { useState, useEffect } from 'react';
import api from "../../../api/api";
import AdminPanel from '../panel/AdminPanel';
import '../styles/CreateFeeStructure.css';
import { FaRupeeSign, FaFlask, FaFootballBall, FaBook, FaBus, FaFileInvoiceDollar } from 'react-icons/fa';

const CreateFeeStructureDashboard = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentFeeType, setCurrentFeeType] = useState('');
  const [feeForm, setFeeForm] = useState({ amount: '', description: '', dueDate: '', class: '' });

  // Selected student fee states
  const [studentFormOpen, setStudentFormOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [studentFeeForm, setStudentFeeForm] = useState({ feeType: '', amount: '', description: '', dueDate: '' });

  // Dynamic data
  const [classes, setClasses] = useState([]);
  const [allStudents, setAllStudents] = useState({});
  
  // ✅ All Fees State
  const [allFees, setAllFees] = useState([]);

  const feeTypes = [
    { label: 'Tuition', icon: <FaRupeeSign />, color: '#0e0792ff' },
    { label: 'Lab', icon: <FaFlask />, color: '#f59e0b' },
    { label: 'Sports', icon: <FaFootballBall />, color: '#10b981' },
    { label: 'Library', icon: <FaBook />, color: '#6366f1' },
    { label: 'Transport', icon: <FaBus />, color: '#f43f5e' },
    { label: 'Exam', icon: <FaFileInvoiceDollar />, color: '#f97316' },
    { label: 'Miscellaneous', icon: null, color: '#0ea5e9' }
  ];

  // Load dynamic data
  useEffect(() => {
    api.get("/api/classes")
      .then(res => setClasses(res.data))
      .catch(err => console.error("❌ Error fetching classes:", err));

    api.get("/api/students")
      .then(res => setAllStudents(res.data))
      .catch(err => console.error("❌ Error fetching students:", err));

    // Fetch all fees
    fetchAllFees();
  }, []);

  useEffect(() => {
    if (selectedClass) {
      setStudents(allStudents[selectedClass] || []);
      setSelectedStudent('');
    }
  }, [selectedClass, allStudents]);

  const fetchAllFees = async () => {
    try {
      const res = await api.get("/api/fees");
      setAllFees(res.data);
    } catch (err) {
      console.error("❌ Error fetching fees:", err);
    }
  };

  const openModal = (feeType) => {
    setCurrentFeeType(feeType);
    setFeeForm({ amount: '', description: '', dueDate: '', class: '' });
    setModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeeForm(prev => ({ ...prev, [name]: value }));
  };

  // Class Fee Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/fees", {
        feeType: currentFeeType,
        classId: feeForm.class,
        studentId: null,
        amount: feeForm.amount,
        description: feeForm.description,
        dueDate: feeForm.dueDate
      });
      alert("✅ Fee created successfully!");
      setModalOpen(false);
      fetchAllFees();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to create fee");
    }
  };

  // Student Fee Submission
  const handleStudentFeeChange = (e) => {
    const { name, value } = e.target;
    setStudentFeeForm(prev => ({ ...prev, [name]: value }));
  };

  const handleStudentFeeSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/fees", {
        feeType: studentFeeForm.feeType,
        classId: selectedClass,
        studentId: selectedStudent,
        amount: studentFeeForm.amount,
        description: studentFeeForm.description,
        dueDate: studentFeeForm.dueDate
      });
      alert("✅ Student Fee created successfully!");
      setStudentFormOpen(false);
      fetchAllFees();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to create student fee");
    }
  };

  return (
    <div>
      <AdminPanel onToggle={setIsSidebarCollapsed} />

      <div className={`notification-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Top Bar */}
        <div className="dashboard-topbar">
          <span className="date-time">TODAY IS {new Date().toLocaleString()}</span>
          <span className="school-name">Semigon Learning</span>
        </div>

        {/* Header */}
        <div className="dashboard-header4">
          <h1><FaRupeeSign /> Create Fee Structure</h1>
        </div>

        {/* Fee Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: '20px', marginBottom: '40px' }}>
          {feeTypes.map(fee => (
            <div
              key={fee.label}
              className="fee-card"
              style={{ textAlign: 'center', padding: '30px', borderRadius: '12px', background: fee.color, color: '#fff', cursor: 'pointer', boxShadow: '0 8px 20px rgba(0,0,0,0.25)' }}
            >
              {fee.icon && <div style={{ fontSize: '30px', marginBottom: '10px' }}>{fee.icon}</div>}
              <div style={{ fontWeight: '700', fontSize: '18px', marginBottom: '12px' }}>{fee.label}</div>
              <button className="send-btn highlighted-btn" onClick={() => openModal(fee.label)}>Create Fee</button>
            </div>
          ))}

          {/* Student Fee */}
          <div
            className="fee-card"
            style={{ textAlign: 'center', padding: '30px', borderRadius: '12px', background: '#6ae074ff', color: '#fff', cursor: 'pointer', boxShadow: '0 8px 20px rgba(0,0,0,0.25)' }}
            onClick={() => setStudentFormOpen(true)}
          >
            <div style={{ fontSize: '30px', marginBottom: '10px' }}>👤</div>
            <div style={{ fontWeight: '700', fontSize: '18px', marginBottom: '12px' }}>Selected Student Fee</div>
            <button className="send-btn highlighted-btn">Create Fee</button>
          </div>
        </div>
      </div>

      {/* --- Student Modal --- */}
      {studentFormOpen && (
        <div className="fee-modal-overlay" onClick={(e) => { if (e.target.classList.contains('fee-modal-overlay')) setStudentFormOpen(false); }}>
          <div className="fee-modal">
            <h2>Create Fee for Selected Student</h2>
            <form onSubmit={handleStudentFeeSubmit}>
              <label>
                Select Class:
                <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} required>
                  <option value="">-- Select Class --</option>
                  {classes.map(cls => <option key={cls.id} value={cls.id}>{cls.name}</option>)}
                </select>
              </label>

              {students.length > 0 && (
                <label>
                  Select Student:
                  <select value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)} required>
                    <option value="">-- Select Student --</option>
                    {students.map(stu => <option key={stu.id} value={stu.id}>{stu.name}</option>)}
                  </select>
                </label>
              )}

              {selectedStudent && (
                <>
                  <label>
                    Fee Type:
                    <select name="feeType" value={studentFeeForm.feeType} onChange={handleStudentFeeChange} required>
                      <option value="">-- Select Fee Type --</option>
                      {feeTypes.map(fee => <option key={fee.label} value={fee.label}>{fee.label}</option>)}
                    </select>
                  </label>

                  <label>
                    Amount:
                    <input type="number" name="amount" value={studentFeeForm.amount} onChange={handleStudentFeeChange} required />
                  </label>

                  <label>
                    Description:
                    <input type="text" name="description" value={studentFeeForm.description} onChange={handleStudentFeeChange} />
                  </label>

                  <label>
                    Due Date:
                    <input type="date" name="dueDate" value={studentFeeForm.dueDate} onChange={handleStudentFeeChange} />
                  </label>

                  <div className="notification-actions">
                    <button type="submit" className="send-btn">Create Fee</button>
                    <button type="button" className="reset-btn" onClick={() => setStudentFormOpen(false)}>Cancel</button>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      )}

      {/* --- Class Fee Modal --- */}
      {modalOpen && (
        <div className="fee-modal-overlay" onClick={(e) => { if (e.target.classList.contains('fee-modal-overlay')) setModalOpen(false); }}>
          <div className="fee-modal">
            <h2>Create {currentFeeType} Fee</h2>
            <form onSubmit={handleSubmit}>
              <label>
                Select Class:
                <select name="class" value={feeForm.class} onChange={handleChange} required>
                  <option value="">-- Select Class --</option>
                  {classes.map(cls => <option key={cls.id} value={cls.id}>{cls.name}</option>)}
                </select>
              </label>

              <label>
                Amount:
                <input type="number" name="amount" value={feeForm.amount} onChange={handleChange} required />
              </label>

              <label>
                Description:
                <input type="text" name="description" value={feeForm.description} onChange={handleChange} />
              </label>

              <label>
                Due Date:
                <input type="date" name="dueDate" value={feeForm.dueDate} onChange={handleChange} />
              </label>

              <div className="notification-actions">
                <button type="submit" className="send-btn">Create Fee</button>
                <button type="button" className="reset-btn" onClick={() => setModalOpen(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* --- All Fees Table --- */}
      <div className="all-fees-table">
        <h2>All Fees</h2>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Fee Type</th>
              <th>Class</th>
              <th>Student</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            {allFees.map(fee => (
              <tr key={fee.id}>
                <td>{fee.id}</td>
                <td>{fee.feeType}</td>
                <td>{fee.className || '-'}</td>
                <td>{fee.studentName || '-'}</td>
                <td>₹{fee.amount}</td>
                <td>{fee.description}</td>
                <td>{fee.dueDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
 
export default CreateFeeStructureDashboard;
